import { setRegisteredData } from "./registered-data";

$('.contact-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');
    
    setRegisteredData(data, 'section#contact');

    // page swap
    $('section#contact .page').prop('hidden', true);
    $('section#contact .page-thank-you').prop('hidden', false);

    // modal (uncomment if you need a modal instead of page swap)
    //$('#modal-form-contact').modal('show');
});